import { render } from "./WorkingGroup.vue?vue&type=template&id=4a540728&scoped=true"
import script from "./WorkingGroup.vue?vue&type=script&lang=js"
export * from "./WorkingGroup.vue?vue&type=script&lang=js"

import "./WorkingGroup.vue?vue&type=style&index=0&id=4a540728&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a540728"]])

export default __exports__